import { render, staticRenderFns } from "./questionType.vue?vue&type=template&id=7f8caa86&scoped=true&"
import script from "./questionType.vue?vue&type=script&lang=js&"
export * from "./questionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f8caa86",
  null
  
)

export default component.exports